import * as Sentry from '@sentry/browser'

const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS

Sentry.init({ dsn: SENTRY_DNS })
